import axiosInstance from "../../../axios/axios";

export const promiseOptions = (searchKeyword, gender = 'Stallion' , timeoutId , setTimeoutId) =>
    new Promise((resolve) => {
        if (timeoutId > 0) {
            clearTimeout(timeoutId);
        }

        const id = setTimeout(async () => {
            const response = await axiosInstance.post(
                "/ServicesRequests/GetRegisteredHorses",
                {
                    lang: localStorage.getItem("eahsLang") ?? "en",
                    searchValue: searchKeyword,
                    gender: gender
                }
            );

            const data = await response.data.horsesList.filter(item => item.gender === gender);

            const options = data.map((item) => ({
                label: item.registerNumber + " - " + item.name,
                value: item.id,
                details: item,
            }));
            resolve(options);
        }, 1000);

        setTimeoutId(id);
    });
